import { useFormikContext } from 'formik'

import { getChatroomMessageTemplate } from '../../../../../api'
import { EMPTY_STRING } from '../../../../../constants/common'
import { useApi } from '../../../../../hooks'
import { hasTinyMceHtmlVisibleText } from '../../../../../utils/html'
import {
  CHATROOM_INPUT_FIELD_NAME_INSERT_REPLACE,
  CHATROOM_INPUT_FIELD_NAME_MESSAGE,
  CHATROOM_INPUT_FIELD_NAME_TEMPLATE,
} from '../../../Chatroom.constants'
import { isChatroomInputInsertReplaceOptionValueInsert } from '../../../Chatroom.utils'
import { ChatroomInputTemplateConfirmationModal } from '../../../ChatroomInputTemplateConfirmationModal'

export function useChatroomInputTemplate({
  addFiles,
  editorRef,
  requestId,
  setModal,
  onCloseModal,
}) {
  const { setFieldValue, values } = useFormikContext()

  const templateApi = useApi()

  function addTemplateFiles(files) {
    if (files?.length > 0) {
      addFiles(files)
    }
  }

  function renderTemplate(templateId) {
    return templateApi.call(getChatroomMessageTemplate, {
      data: {
        ...(requestId ? { request_id_outside_email: requestId } : null),
        replace_undefined: true,
      },
      id: templateId,
    })
  }

  function insertTemplateText(text) {
    if (text && editorRef.current) {
      editorRef.current.focus()
      editorRef.current.selection.select(editorRef.current.getBody(), true)
      editorRef.current.selection.collapse(false)
      editorRef.current.insertContent(text)
    }
  }

  function replaceTemplateText(text) {
    setFieldValue(CHATROOM_INPUT_FIELD_NAME_MESSAGE, text || EMPTY_STRING)
  }

  function closeConfirmationModal() {
    setFieldValue(CHATROOM_INPUT_FIELD_NAME_TEMPLATE, null)
    onCloseModal()
  }

  function handleSubmitConfirmation({ confirmation, template }) {
    const shouldInsert = isChatroomInputInsertReplaceOptionValueInsert(
      confirmation[CHATROOM_INPUT_FIELD_NAME_INSERT_REPLACE]
    )

    renderTemplate(template.value)
      .then(response => {
        if (response) {
          const text = response.data?.text

          if (shouldInsert) {
            insertTemplateText(text)
          } else {
            replaceTemplateText(text)
          }

          addTemplateFiles(response.data?.files)
        }
      })
      .finally(closeConfirmationModal)
  }

  function handleChangeTemplate(template) {
    setFieldValue(CHATROOM_INPUT_FIELD_NAME_TEMPLATE, template)

    if (template) {
      const hasContent = hasTinyMceHtmlVisibleText(
        values[CHATROOM_INPUT_FIELD_NAME_MESSAGE]
      )

      if (hasContent) {
        setModal(
          <ChatroomInputTemplateConfirmationModal
            onClose={closeConfirmationModal}
            onSubmit={confirmation =>
              handleSubmitConfirmation({ confirmation, template })
            }
          />
        )
      } else {
        renderTemplate(template.value).then(response => {
          if (response) {
            replaceTemplateText(response.data?.text)
            addTemplateFiles(response.data?.files)
          }
        })
      }
    }
  }

  function handleClearTemplate() {
    setFieldValue(CHATROOM_INPUT_FIELD_NAME_TEMPLATE, null)
  }

  return { handleChangeTemplate, handleClearTemplate }
}
